import { useState, useEffect, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Currency → supported Flutterwave payment options (merchant-side)
// Reference: https://developer.flutterwave.com/docs/payment-options
const CURRENCY_METHODS = {
  USD:  ["card", "banktransfer"],
  NGN:  ["card", "banktransfer", "ussd"],
  GHS:  ["card", "mobilemoneyghana"],
  KES:  ["card", "mpesa"],
  UGX:  ["card", "mobilemoneyuganda"],
  RWF:  ["card", "mobilemoneyrwanda"],
  TZS:  ["card"],
  ZAR:  ["card"],
  XAF:  ["card", "mobilemoneyfranco"],
  XOF:  ["card", "mobilemoneyfranco"],
  ZMW:  ["card", "mobilemoneyzambia"],
};

export function usePaymentConfig() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/payments/config`)
      .then((r) => setConfig(r.data))
      .catch(() => setConfig(null))
      .finally(() => setLoading(false));
  }, []);

  return { config, loading };
}

/**
 * Returns payment_options string filtered to methods that:
 *  (a) the merchant has enabled in admin panel
 *  (b) are supported for the chosen currency
 * Returns empty string if no method works → caller should show a friendly error.
 */
export function getPaymentOptionsForCurrency(config, currency) {
  if (!config) return "";
  const supported = CURRENCY_METHODS[currency] || ["card"];
  const enabled = config.enabled_methods || {};
  const allowed = supported.filter((m) => enabled[m] !== false);
  return allowed.join(",");
}

export function useFilteredPaymentOptions(config, currency) {
  return useMemo(() => getPaymentOptionsForCurrency(config, currency), [config, currency]);
}
